define('TescoMobile_Checkout/js/sidebar-mixin',['jquery', 'Magento_Customer/js/model/authentication-popup', 'Magento_Customer/js/customer-data', 'Magento_Ui/js/modal/alert', 'Magento_Ui/js/modal/confirm', 'underscore', 'mage/decorate', 'mage/collapsible', 'mage/cookies'], function ($, authenticationPopup, customerData, alert, confirm, _) {
  'use strict';

  var sidebarWidgetMixin = {
    options: {
      isRecursive: true,
      minicart: {
        maxItemsVisible: 1
      }
    },
    scrollHeight: 0,
    shoppingCartUrl: window.checkout.shoppingCartUrl,
    handles: [],
    _calcHeight: function () {
      var self = this,
        height = 0,
        counter = this.options.minicart.maxItemsVisible,
        target = $(this.options.minicart.list),
        outerHeight;
      self.scrollHeight = 0;
      target.children().each(function () {
        if ($(this).find('.options').length > 0) {
          $(this).collapsible();
        }
        outerHeight = $(this).outerHeight(true);
        if (counter-- > 0) {
          height += outerHeight;
        }
        self.scrollHeight += outerHeight;
      });
    }
  };
  return function (targetWidget) {
    $.widget('mage.sidebar', targetWidget, sidebarWidgetMixin);
    return $.mage.sidebar;
  };
});

